import { formatDate } from './bits.jsx';

export default function TrainerView({ entity }) {
  return (
    <dl className="quiz-facts">
      <div>
        <dt>Email</dt>
        {/* trainerEmail is what this collection stores; `email` is a
            convenience some endpoints add and others do not. */}
        <dd>{entity?.trainerEmail || entity?.email || '—'}</dd>
      </div>
      <div>
        <dt>Phone</dt>
        <dd>{entity?.trainerPhone || entity?.phone || entity?.mobile || '—'}</dd>
      </div>
      <div>
        <dt>Specialization</dt>
        <dd>{entity?.specialization || '—'}</dd>
      </div>
      <div>
        <dt>Experience</dt>
        <dd>{entity?.experience ? `${entity.experience} years` : '—'}</dd>
      </div>
      <div>
        <dt>Added</dt>
        <dd>{formatDate(entity?.createdAt)}</dd>
      </div>
    </dl>
  );
}
